
export default {
  head() {
    return {
      title: "Création site internet à Lyon | À partir 69€HT/mois",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous voulez créer un site web pour votre activité à Lyon ? Découvrez les solutions digitales à des prix accessibles proposées par l’agence de communication ALEO !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Création site internet Lyon | À partir 69€HT/mois",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous voulez créer un site web pour votre activité à Lyon ? Découvrez les solutions digitales à des prix accessibles proposées par l’agence ALEO !",
        },
      ],
    };
  },
};
